var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSafetyMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#safety-mark_svg__clip0_7547_33169)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 21.5l-8.503-4.602a2 2 0 01-1.025-2.062L2.16 3.837a11.661 11.661 0 0115.678 0l1.69 11a2 2 0 01-1.026 2.061L10 21.5z",
    fill: "#0D8E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.58 15.192a.06.06 0 00.03-.062L16.032 4.846a9.723 9.723 0 00-12.062 0L2.39 15.13a.06.06 0 00.03.062L10 19.294l7.58-4.102zM10 21.5l-8.503-4.602a2 2 0 01-1.025-2.062L2.16 3.837a11.661 11.661 0 0115.678 0l1.69 11a2 2 0 01-1.026 2.061L10 21.5z",
    fill: "#242529"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.402 6.65l2.062 1.413-4.626 6.75-4.533-2.746L6.6 9.927l2.51 1.523 3.292-4.8z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "safety-mark_svg__clip0_7547_33169"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v22H0z"
  })))));
}

export default SvgSafetyMark;